import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SelectGroupsQueryVariables = Types.Exact<{
  input: Types.SelectGroupsInput;
}>;


export type SelectGroupsQuery = { selectGroups?: { groupIds?: Array<string> | null } | null };


export const SelectGroupsDocument = /*#__PURE__*/ gql`
    query selectGroups($input: SelectGroupsInput!) {
  selectGroups(input: $input) {
    groupIds
  }
}
    `;

export function useSelectGroupsQuery(options: Omit<Urql.UseQueryArgs<SelectGroupsQueryVariables>, 'query'>) {
  return Urql.useQuery<SelectGroupsQuery, SelectGroupsQueryVariables>({ query: SelectGroupsDocument, ...options });
};